import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {SharedModule} from '../../../../core/modules/shared.module';
import {EditUserDialogComponent} from './edit.user.dialog.component';

const routes = [{path: 'userdialog', component: EditUserDialogComponent}];

@NgModule({
  declarations: [EditUserDialogComponent],
  imports: [SharedModule, RouterModule.forChild(routes)],
  exports: [EditUserDialogComponent]
})

export class EditUserModule {}


// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/users/edit/edit.user.dialog.module.ts